export default __webpack_public_path__ + "static/media/settings.263b136f.svg";